"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _payouts = require("@module/payouts");

var _filters = require("@preloader/filters");

var _moment = _interopRequireDefault(require("@package/moment"));

var _utils = require("@package/utils");

var _hoc = require("@package/hoc");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _Component = _interopRequireDefault(require("./Component"));

var PAGING_TAKE = Number(window.env['PAGING_TAKE']);

function HOC() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var location = (0, _reactRouterDom.useLocation)();
  var preloadingProcess = (0, _reactRedux.useSelector)(_payouts.selectPreloadingProcess);

  function processing(_x) {
    return _processing.apply(this, arguments);
  }

  function _processing() {
    _processing = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(params) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch((0, _payouts.setPreloadingProcess)(true));
              _context3.next = 3;
              return dispatch((0, _payouts.getPayouts)((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
                order: 'created',
                dateFrom: (0, _moment["default"])().subtract(1, 'months').format('YYYY-MM-DD 00:00:00.000000+03:00'),
                dateTo: (0, _moment["default"])().format('YYYY-MM-DD 23:59'),
                status: -1,
                searchTerm: null,
                amountFrom: null,
                amountTo: null
              }, params), {}, {
                page: typeof params['page'] === 'number' ? params['page'] : 1,
                take: typeof params['take'] === 'number' ? params['take'] : PAGING_TAKE
              })));

            case 3:
              dispatch((0, _payouts.setPreloadingProcess)(false));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _processing.apply(this, arguments);
  }

  (0, _hoc.useMount)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
    var query;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            document.title = "".concat(process.env['REACT_APP_WEBSITE_NAME'], " - \u0412\u044B\u043F\u043B\u0430\u0442\u044B");
            query = (0, _utils.queryToObject)(location['search']);
            _context.next = 4;
            return processing(query);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
  (0, _hoc.useUpdate)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
    var query;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = (0, _utils.queryToObject)(location['search']);
            _context2.next = 3;
            return processing(query);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  (0, _hoc.useUnmount)(function () {
    dispatch((0, _payouts.resetStateAction)());
  });

  if (preloadingProcess) {
    return /*#__PURE__*/_react["default"].createElement(_filters.Preloader, null);
  } else {
    return /*#__PURE__*/_react["default"].createElement(_Component["default"], null);
  }
}

var _default = HOC;
exports["default"] = _default;